function TimeClockSummaryTable({ rows }) {
	const items = Array.isArray(rows) ? rows : [];

	return (
		<section className="admin-time-clock-card" aria-label="Employee hours summary">
			<h3>Employee Summary</h3>
			<div className="admin-time-clock-table-wrap">
				<table className="admin-time-clock-table">
					<thead>
						<tr>
							<th>Employee</th>
							<th>Total</th>
							<th>Sessions</th>
							<th>Active Days</th>
							<th>Avg Session</th>
							<th>Open Sessions</th>
						</tr>
					</thead>
					<tbody>
						{items.length === 0 ? (
							<tr>
								<td colSpan={6} className="admin-time-clock-empty-cell">
									No records in selected range.
								</td>
							</tr>
						) : (
							items.map((row) => (
								<tr key={row.userId}>
									<td>
										<div className="admin-time-clock-user-cell">
											<strong>{row.userName}</strong>
											<small>{row.userEmail || "-"}</small>
										</div>
									</td>
									<td>{row.totalDurationLabel}</td>
									<td>{row.sessionCount}</td>
									<td>{row.activeDayCount}</td>
									<td>{row.averageDurationLabel}</td>
									<td>{row.openSessionCount}</td>
								</tr>
							))
						)}
					</tbody>
				</table>
			</div>
		</section>
	);
}

export default TimeClockSummaryTable;
